<template>
  <div>
    <div class="row">
      <div class="col-12">
        <vue-dropzone :useCustomSlot=true ref="dropzone" id="dropzone" v-on:vdropzone-success="uploadProdutosdeArquivo" v-on:vdropzone-removed-file="limpaProdutosSelecionados" :options="dropzoneOptions">
          <div class="dropzone-custom-content">
            <h3 class="dropzone-custom-title">
              Arraste e solte para importar de um arquivo!
            </h3>
            <div class="dropzone-custom-subtitle">...ou clique para selecionar um arquivo do seu computador</div>
          </div>
        </vue-dropzone>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-6">
        <label class="field-label">Filtrar produtos</label>
        <input type="text" class="form-control form-control-sm" v-model="filter" placeholder="Filtrar por id ou descricao">
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="scrollable lista-clientes" style="height: 300px;">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
              <tr>
                <th>ID</th>
                <th>Descrição</th>
                <th>#</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="produto in produtosFiltered">
                <td>{{ produto.id }}</td>
                <td>{{ produto.descComp }}</td>
                <td>
                  <CButton size="sm" color="success" variant="ghost" @click="onSelectProduto(produto.id)" title="Adicionar">
                    <fa-icon icon="plus" />
                  </CButton>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="scrollable lista-clientes" style="height: 300px;">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
              <tr>
                <th colspan="3">
                  Produtos Vinculados
                  <small class="small-text-info text-gray">({{ produtosSelecionados.length}}/{{produtos.length}})</small>
                  <CButton size="sm" color="danger" variant="ghost" class="float-right" v-if="produtosSelecionados.length" @click="limpaProdutosSelecionados" title="Limpar todos">
                    <fa-icon icon="trash-alt" /> Limpar todos
                  </CButton>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="produto in produtosSelecionados">
                <td class="highlight">{{ produto.id }}</td>
                <td class="highlight">{{ produto.descComp }}</td>
                <td class="actions">
                  <CButton size="sm" color="danger" variant="ghost" @click="onRemoveProduto(produto.id)" title="Remover">
                    <fa-icon icon="trash-alt" />
                  </CButton>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
#dropzone {
  position: relative;
  border: 2px dashed #dddce9;
  border-radius: 10px;
  background: #f9fafb;
  min-height: 120px;
  margin-bottom: 16px;
}

.dropzone-custom-content {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  color: #3a3e81;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 4px;
  background-color: initial;
}

.dropzone-custom-subtitle {
  color: #667085;
  font-size: 12px;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.lista-clientes {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.lista-clientes .table {
  margin-bottom: 0;
}

.lista-clientes .table thead th {
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 10px 14px;
  white-space: nowrap;
}

.lista-clientes .table tbody td {
  padding: 8px 14px;
  font-size: 13px;
  color: #344054;
  vertical-align: middle;
}

.lista-clientes .table tbody td.highlight {
  font-weight: 500;
  color: #3a3e81;
}

.lista-clientes .table tbody td.actions {
  text-align: right;
  white-space: nowrap;
}
</style>

<script>

  import vue2Dropzone from "vue2-dropzone";
  import "vue2-dropzone/dist/vue2Dropzone.min.css";  
  import setup from "../../../config";
  import _some from "lodash/some";
  import _find from "lodash/find";
  import _concat from "lodash/concat";
  import _filter from "lodash/filter";
  import _difference from "lodash/difference";
  import { toMonetary, isNumeric } from "../../../helpers/utils";
  

  const dropzoneDictionary = {
    dictDefaultMessage:
      "Arraste um arquivo .xls(x) ou clique para importar produtos",
    dictFallbackMessage:
      "Seu navegador não suporta upload o recurso de arrastar e soltar",
    dictFileTooBig: "O arquivo excedeu o tamanho máximo permitido (5MB)",
    dictInvalidFileType: "Arquivo no formato inválido",
    dictResponseError: "Erro ao processar solicitação, tente novamente!",
    dictCancelUpload: "Cancelar",
    dictCancelUploadConfirmation: "Tem certeza?",
  };

  export default {
    name: "cupomProdutos",
    components: {
      vueDropzone: vue2Dropzone,
    },
    props: [
      "item",      
      "produtos",
    ],
    data() {
      return {
        filter: "",
        dropzoneOptions: {
          url: `${setup.api}/admin/cupons/importar-produtos`,
          acceptedFiles: ".xls, .xlsx",
          maxFilesize: 5,
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          paramName: "produtos",
          ...dropzoneDictionary,
        },
      };
    },
    methods: {
      uploadProdutosdeArquivo(arquivo, resposta) {
        const idsValidos = _filter(resposta.produtos, (id) => {
          return _find(this.produtos, (produto) => `${produto.id}` === `${id}`);
        });
        const newClients = _difference(idsValidos, this.item.produtos);
        this.item.produtos = _concat(this.item.produtos, newClients);
      },
      onSelectProduto(id) {
        this.item.produtos.push(id);        
      },
      onRemoveProduto(id) {
        this.item.produtos = _filter(this.item.produtos, (idProduto) => {
          return +id !== +idProduto;
        });
      },
      limpaProdutosSelecionados() {
        this.$refs.dropzone.removeAllFiles();
        this.item.produtos = [];
      },
    },
    computed: {
      produtosFiltered() {
        if (!this.item.produtos) {
          return [];
        }

        const toFilter = this.produtos.filter((loja) => {
          return !this.item.produtos.some((id) => `${id}` === `${loja.id}`);
        });

        let text = this.filter;

        if (text) {
          return toFilter
            .filter((loja) => {
              text = text.toLowerCase();

              // Filtro por ID
              if (isNumeric(text) && loja.id && loja.id === text) {
                return true;
              }

              // Filtro por Descrição
              if (loja.descComp && loja.descComp.toLowerCase().match(text)) {
                return true;
              }
            })
            .slice(0, this.resultLimit);
        }

        return toFilter.slice(0, this.resultLimit);
      },
      produtosSelecionados() {
        if (this.item.produtos && !this.item.produtos.length === 0) {
          return [];
        }
        return _filter(this.produtos, (produto) => {
          return (
            _some(this.item.produtos, (id) => `${produto.id}` === `${id}`) ||
            false
          );
        });
      },
    },
  };
</script>
